<template>

<v-dialog v-model="show" id="unwrap-eth"
	persistent max-width="400px" :fullscreen="fullscreen" >

	<v-card>

		<!--Modal Title -->
		<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
			<v-toolbar-title>{{ $t('compUnwrap.title') }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon @click="show = false">
				<v-icon>mdi-window-close</v-icon>
			</v-btn>
		</v-toolbar>

		<!-- Modal Contents -->
		<v-card-text class="pa-5">

			<div class="title text-center mb-3">{{ $t('compUnwrap.title') }}</div>

			<div class="caption mb-3" v-show="!txHash">{{ $t('myTokensPage.tooltipTxtWrapUnWrap') }}</div>

			<v-form ref="form" v-if="show && !txHash" v-model="valid">
				<v-text-field
					outlined color="gray" persistent-hint
					:label="$t('compUnwrap.labelAmount')"
					id="unwrap-eth-amount"
					v-model.number.trim="input.amount"
					:rules="rules.amount"
					type="number"
					placeholder=""
					suffix="WETH"
					:hint="$t('common.noun.balance') + ': ' + formatAmountNumber(account.WETHBalance)"
					required
				></v-text-field>

				<div class="text-center my-3">
					<v-btn color="success" :disabled="!valid || loading" @click="unwrapETH()" v-show="!txHash" >
						{{ $t('compUnwrap.btnConvert') }} <ButtonLoading v-show="loading" class="ml-3" />
					</v-btn>
				</div>

			</v-form>

			<div class="text-center my-2 mx-3" v-if="txHash">
				<PendingTransaction :txhash="txHash" :txurl="networkConfig.txURL"></PendingTransaction>
			</div>

		</v-card-text>

		<v-card-actions v-if="fullscreen">
			<v-spacer></v-spacer>
			<v-btn color="primary" outlined text class="mr-3" @click="show = false">
				<v-icon>mdi-window-close</v-icon> {{ $t('common.verb.close')}}
			</v-btn>
		</v-card-actions>

	</v-card>
</v-dialog>


</template>

<script>

import { config } from '@/config'
import { ERC20TokenContract } from '@0x/contract-wrappers'
import { BigNumber } from '@0x/utils'
import { Web3Wrapper } from '@0x/web3-wrapper'
import PendingTransaction from "@/components/PendingTransaction"
import {mapActions, mapGetters, mapState} from 'vuex'
import { formatAmountNumber, countDecimals } from '@/utils/utils'
import ButtonLoading from "@/components/ButtonLoading"

export default {
	name: 'UnwrapETH',
	components: {
		PendingTransaction,
		ButtonLoading
	},
	props: {
		fullscreen: { type: Boolean, default: false},
	},
	data () {
		return {
			config: config,
			input: {
				amount: null
			},
			valid: true,
			initializationDone: false,
			showWaitingNetwork: false,
			txHash: null,
			loading: false,
			show: false,
			rules: {
				amount: [
					// Field is required
					val => (val !== null && val !== undefined && val !== '') || this.$t('common.phrase.fieldIsRequired'),
					// Must be a number
					val => !isNaN(val) || this.$t('common.err.amount.mustNumber'),
					// Must greater than zero
					val => val > 0 || this.$t('common.err.amount.mustGreaterThanZero'),
					// Must less than the current balance
					val => val < this.account.WETHBalance ||
								this.$t('common.err.amount.insufficientBalance') + ": (" + this.$t('common.err.amount.max') + ': ' +
								formatAmountNumber(this.account.WETHBalance) + ')',
					// Must not have too many decimals
					val => (countDecimals(val) <= config.inputAmountMaxDecimals) ||
								this.$t('common.err.amount.tooManyDecimals') + ": (" + this.$t('common.err.amount.max') + ': ' +
								config.inputAmountMaxDecimals + ')',
				]
			}
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			myAddress: 'getUserAccount',
			web3Wrapper: 'getWeb3Wrapper',
			providerEngine: 'getProviderEngine',
			contractWrappers: 'getContractWrappers',
			contractAddresses: 'getContractAddresses',
			networkConfig: 'getNetworkConfig'
		}),
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount']),
		formatAmountNumber: formatAmountNumber,
		countDecimals: countDecimals,
		async showForm () {
			this.valid = true
			this.input.amount = null
			this.txHash = null
			this.loading = false
			this.show = true
		},
		async unwrapETH () {
			const amount = this.input.amount
			if (!amount) {
				throw new Error ("invalid WETH amount to convert")
			}
			const wethAmount = Web3Wrapper.toBaseUnitAmount(new BigNumber(amount), config.ETHDecimals)
			const etherToken = this.contractWrappers.weth9
			this.loading = true
			try {
				this.txHash = await etherToken.withdraw(wethAmount).sendTransactionAsync({
					from: this.myAddress
				})
				await this.web3Wrapper.awaitTransactionMinedAsync(this.txHash)
				await this.loadAccount(true)
				this.$parent.$emit("successNotification", this.$t('compUnwrap.successMessage', {amount: this.input.amount}))
			} catch (err) {
				console.log(err)
			} finally {
				this.loading = false
				this.show = false
			}
		}
	},
	created () {
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
